/**
 * @fileoverview MultipassPageHeader — inner page header used by Roles,
 * Markings, Groups, etc. Left side: `<h3>` title + muted description. Right
 * side: an actions slot (typically a filter `InputGroup` + create `Button`).
 *
 * Foundry mapping: `multipass-internal__settings-header` with
 * `multipass-internal__text` (title + description) and
 * `multipass-internal__actions`. Distinct from the outer SettingsHeader
 * (which lives in the control-panel shell with icon + breadcrumb).
 */

import type { ReactNode } from "react";

interface MultipassPageHeaderProps {
  title: string;
  description?: ReactNode;
  /** Right-side actions row — filter inputs, primary buttons, etc. */
  actions?: ReactNode;
  className?: string;
}

export function MultipassPageHeader({
  title,
  description,
  actions,
  className,
}: MultipassPageHeaderProps) {
  return (
    <div data-testid="multipass-page-header" className={["bp-mp-page-header", className].filter(Boolean).join(" ")}>
      <div className="bp-mp-page-header-text">
        <h3 className="bp6-heading bp-mp-page-header-title">{title}</h3>
        {description !== undefined && (
          <div className="bp6-text-muted bp-mp-page-header-description">{description}</div>
        )}
      </div>
      {actions !== undefined && <div className="bp-mp-page-header-actions">{actions}</div>}
    </div>
  );
}
